/* KartComms — KC-PRO Premium Kit landing page.
   Sticky mobile CTA reveal + scroll-in reveals + accessible FAQ height animation.
   All content is visible by default; JS only enhances. */
(function () {
  'use strict';

  if (window.__kclInit) return;          // snippet may load this once per section; run only once
  window.__kclInit = true;

  var root = document.querySelector('.kcl');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---- scroll reveals ---- */
  if (!reduce && hasIO) {
    var reveals = root.querySelectorAll('.kcl-reveal, .kcl-stagger');
    if (reveals.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---- sticky mobile CTA: show once the hero offer scrolls out of view ---- */
  var sticky = root.querySelector('.kcl-sticky');
  var anchor = root.querySelector('[data-sticky-anchor]');
  if (sticky && anchor && hasIO) {
    var sObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // anchor (hero offer) above the viewport top => past the fold => show bar
        var past = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-shown', past);
      });
    }, { threshold: 0 });
    sObs.observe(anchor);
  }

  /* ---- FAQ: smooth open/close height (native <details> stays the source of truth) ---- */
  var faqs = root.querySelectorAll('.kcl-q');
  faqs.forEach(function (d) {
    var panel = d.querySelector('.kcl-q__a');
    if (!panel) return;
    var summary = d.querySelector('summary');
    if (reduce) return; // native instant toggle is fine

    summary.addEventListener('click', function (ev) {
      ev.preventDefault();
      if (d.open) {
        var start = panel.scrollHeight;
        panel.style.height = start + 'px';
        requestAnimationFrame(function () {
          panel.style.transition = 'height .32s cubic-bezier(.16,1,.3,1)';
          panel.style.height = '0px';
        });
        panel.addEventListener('transitionend', function close() {
          d.open = false; panel.style.transition = ''; panel.style.height = '';
          panel.removeEventListener('transitionend', close);
        });
      } else {
        d.open = true;
        var h = panel.scrollHeight;
        panel.style.height = '0px';
        requestAnimationFrame(function () {
          panel.style.transition = 'height .32s cubic-bezier(.16,1,.3,1)';
          panel.style.height = h + 'px';
        });
        panel.addEventListener('transitionend', function open() {
          panel.style.transition = ''; panel.style.height = '';
          panel.removeEventListener('transitionend', open);
        });
      }
    });
  });
})();
